export default "__VITE_ASSET__D2$nK80I__"